import { useEffect } from "react";
import { useQuery } from "react-query";
import { api } from "services/api";
import { handleRequestError } from "utils/Request";

export type WaitingResponseContact = {
  id: string;
  name: string;
  phone_number: string;
  agent_id: string;
  agent_name: string;
  last_agent_message_at: string;
};

async function fetchWaitingResponseContacts(categoryId?: string): Promise<WaitingResponseContact[]> {
  const { data } = await api.get('/support/agents/waiting-response', {
    params: categoryId ? { category_id: categoryId } : undefined,
  });
  return data;
}

export function useWaitingResponseContacts(categoryId?: string) {
  const query = useQuery(
    ['waiting-response-contacts', categoryId],
    () => fetchWaitingResponseContacts(categoryId),
    { refetchInterval: 60_000 }
  );

  useEffect(() => {
    if (!query.isError) return;
    handleRequestError(query.error, 'Erro ao listar contatos aguardando resposta.');
  }, [query.isError, query.error]);

  return query;
}
